import { Pico } from '../despacho/Pico';
import { Producto } from './Producto';

export class Expendedora  {
    codigo: string;
    nombre: string    
    picos: Pico[];
    productoActual: Producto;
    tipoExpendedora: number;
    activo: boolean;
  }
